import { render, staticRenderFns } from "./integrations-rvm-api.vue?vue&type=template&id=3fa54381"
import script from "./integrations-rvm-api.vue?vue&type=script&lang=js"
export * from "./integrations-rvm-api.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports